// extracted by mini-css-extract-plugin
export default {"container":"fca-z","creativeContainer":"gca-z","copy":"hca-z","cta":"ica-z","disabled":"jca-z","flipped":"kca-z","productCard":"lca-z"};